import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { Button as BtnPrimary } from "@talentbait/shared-components";
import LoadingIndicator from "react-loading-indicator";
import logger from "../../utils/LoggerFrontend";
import { withRouter } from "react-router-dom";
import { LoadingButton, LoadingContainer, LoadingText } from "./LoadingView.styled";
import { t } from "i18next";

const LoadingView = ({
  msg,
  showSpinner,
  // Router
  redirect,
  location,
  history
}) => {
  const message = msg || location?.state?.msg;
  const spinner = Boolean(showSpinner || location?.state?.showSpinner);

  useEffect(() => {
    logger.debug("LoadingView:componentDidMount", "called", location?.state);

    if (location?.state?.redirect) {
      setTimeout(() => {
        history.push(location?.state?.redirect);
      }, 2000);
      return;
    }

    if (redirect) {
      setTimeout(() => {
        history.push(redirect);
      }, 2000);
    }
  }, [location?.state, redirect, history]);

  const reloadPage = () => {
    logger.log("LoadingView:reloadPage", "called");
    history.push("/dashboard");
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  return (
    <LoadingContainer>
      <LoadingText direction={spinner ? "row" : "column"}>
        {message}
        {spinner ? (
          <LoadingIndicator />
        ) : (
          <LoadingButton>
            <BtnPrimary size="medium" type="primary" onClick={() => reloadPage()}>
              {t("Refresh page")}
            </BtnPrimary>
          </LoadingButton>
        )}
      </LoadingText>
    </LoadingContainer>
  );
};

export default withRouter(withTranslation()(LoadingView));
